import coverImage from 'img/facebook-popup/must-phone.png';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { MobileDialog } from 'reactApp/ui/FacebookEmergencyDialog/components/MobileDialog';
import { parseURL } from 'reactApp/utils/helpers';
import opener from 'reactApp/utils/opener';

import { MUST_ATTACH_PHONE_CONTENT } from './FacebookEmergencyDialog.constants';

export const MustAttachPhoneDialog = () => {
    const isMobile = useSelector(EnvironmentSelectors.isMobile);
    const recoveryUrl = useMemo(() => {
        const currentUrl = parseURL(window.location.href);
        // передаю в backUrl текущий урл без get параметров
        const backUrl = `${currentUrl.origin}${currentUrl.pathname}?action=fb-emergency-dialog`;

        return decodeURIComponent(`${MUST_ATTACH_PHONE_CONTENT.recoveryUrl}?back_url=${backUrl}`);
    }, []);

    return isMobile ? (
        <MobileDialog
            closable={false}
            title={MUST_ATTACH_PHONE_CONTENT.title}
            buttonText={MUST_ATTACH_PHONE_CONTENT.buttonText}
            onClickButton={() => opener(recoveryUrl, true)}
            imgProps={{
                height: 247,
                src: coverImage,
                alt: MUST_ATTACH_PHONE_CONTENT.title,
            }}
        >
            {MUST_ATTACH_PHONE_CONTENT.contentText}
        </MobileDialog>
    ) : (
        <WhatsNewDialog
            closable={false}
            imageFluid={false}
            primaryButtonText={MUST_ATTACH_PHONE_CONTENT.buttonText}
            primaryButtonHref={recoveryUrl}
            title={MUST_ATTACH_PHONE_CONTENT.title}
            text={MUST_ATTACH_PHONE_CONTENT.contentText}
            imageUrl={coverImage}
            imageBgColor="#E7EDFB"
        />
    );
};
